interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  fill?: boolean;
  title?: string
}

export const Heart = ({
  width = 20,
  height = 18,
  hexColor = "#282C2F",
  fill,
  title
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {
        title?.length ?
          <title>{title}</title>
          :
          <></>
      }
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M17.2208 2.44251C16.7963 1.98734 16.2827 1.62439 15.7119 1.37623C15.1411 1.12806 14.5254 1 13.903 1C13.2806 1 12.6648 1.12806 12.0941 1.37623C11.5233 1.62439 11.0097 1.98734 10.5852 2.44251C10.2697 2.78498 10.0047 3.17066 9.79809 3.58791C9.59139 3.17033 9.32579 2.78459 9.00942 2.44251C8.58467 1.98777 8.07097 1.62519 7.50022 1.3773C6.92947 1.12941 6.31385 1.00149 5.69159 1.00149C5.06934 1.00149 4.45372 1.12941 3.88297 1.3773C3.31222 1.62519 2.79852 1.98777 2.37377 2.44251C1.49106 3.38638 1 4.6304 1 5.92271C1 7.21502 1.49106 8.45904 2.37377 9.40291L9.79809 17L17.2208 9.40451C18.1057 8.46145 18.5983 7.21675 18.5983 5.92351C18.5983 4.63027 18.1057 3.38557 17.2208 2.44251Z"
            fill={fill ? hexColor : ""}
            stroke={hexColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default Heart;
